import axios from '../axios';

export default {
  loadTemporaryAbonents (options) {
    const params = {};

    if (options.filters && Object.keys(options.filters).length) {
      for (const filterName in options.filters) {
        const value = options.filters[filterName];
        if (Array.isArray(value)) {
          if (!value.length) {
            continue;
          }
          params[`filter[${filterName}]`] = value.join(',');
        } else if (value !== '' && value != null) {
          params[`filter[${filterName}]`] = value;
        }
      }
    }

    if (options.pagination) {
      params.pagination = 1;
    }

    const query = [];
    for (const param in params) {
      query.push(encodeURIComponent(param) + '=' + encodeURIComponent(params[param]));
    }

    return new Promise((resolve, reject) => {
      axios.get('/temporary-abonents?' + query.join('&'))
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },

  newTemporaryAbonent (data) {
    return new Promise((resolve, reject) => {
      axios.post('/temporary-abonents', data)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },

  updateTemporaryAbonent ({ data, id }) {
    return new Promise((resolve, reject) => {
      axios.put(`/temporary-abonents/${id}`, data)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },

  deleteTemporaryAbonent (id) {
    return new Promise((resolve, reject) => {
      axios.delete(`/temporary-abonents/${id}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => reject(error));
    });
  },
};
